import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import {
  MEDIA_LABEL_ICON_DATA_HOOK,
  MEDIA_LABEL_TEXT_DATA_HOOK,
} from './dataHooks';

export interface MediaLabelDriver extends BaseUniDriver {
  isMobile(): Promise<boolean>;
  hasIcon(): Promise<boolean>;
  hasText(): Promise<boolean>;
  getText(): Promise<string>;
}

export const mediaLabelDriverFactory = (base: UniDriver): MediaLabelDriver => {
  return {
    ...baseUniDriverFactory(base),
    isMobile: async () => (await base.attr('data-mobile')) === 'true',
    async hasIcon() {
      return base.$(`[data-hook="${MEDIA_LABEL_ICON_DATA_HOOK}"]`).exists();
    },
    async hasText() {
      return base.$(`[data-hook="${MEDIA_LABEL_TEXT_DATA_HOOK}"]`).exists();
    },
    async getText() {
      return base.$(`[data-hook="${MEDIA_LABEL_TEXT_DATA_HOOK}"]`).text();
    },
  };
};
